import { forwardRef } from 'react';

export const PhoneButtonIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          d="M18.732 17.813l-.003.008-.003.008c-.003.006-.044.082-.2.218s-.402.307-.745.497c-.588.318-1.129.456-1.633.456-.161 0-.317-.01-.469-.031-.139-.019-.309-.055-.512-.113l-.474-.146-.614-.227-.58-.213c-.681-.244-1.275-.528-1.788-.847h-.001c-.882-.548-1.822-1.314-2.821-2.312s-1.764-1.94-2.313-2.821v-.001c-.319-.512-.603-1.106-.847-1.788l-.213-.58-.227-.614-.146-.474a3.68 3.68 0 0 1-.113-.512A3.51 3.51 0 0 1 5 7.852c0-.504.138-1.045.456-1.633.19-.343.358-.585.497-.745s.211-.196.217-.2l.008-.003.008-.003c.107-.047.298-.11.6-.179l.351-.068.173.325.014.027.015.026.327.59.405.734.367.633.027.044.031.041c0 0 .013.017.048.067l.128.185.056.082c-.165.169-.343.325-.535.468-.288.215-.558.445-.807.69-.141.138-.281.297-.392.476-.106.171-.231.434-.231.76a1.75 1.75 0 0 0 .119.603l.14.333c.049.098.124.224.203.351l.088.143.017.029.002.004c.615 1.109 1.328 2.076 2.145 2.893s1.784 1.53 2.892 2.145l.004.002.029.017.143.088.351.203a3.44 3.44 0 0 0 .333.14c.155.057.367.119.603.119.326 0 .588-.125.76-.231.179-.111.338-.251.476-.392.245-.25.475-.519.69-.807.143-.192.299-.37.468-.535l.082.056.185.128.067.047.041.031.044.026.633.367.734.405.59.328.027.015.027.014.325.173-.068.351c-.069.302-.132.492-.179.6zm-6.366-1.144h0z"
          fill="#fff"
          stroke="#fff"
          strokeWidth="2"
        />
      </svg>
    );
  },
);
